import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [getTemplateVendorList 설정 > 네트워크 설정 > 스트립트 설정에서 템플릿 스크립트를 제공하는 벤더만 가져온다.]
   * @author yelim
   * @return {[type]} [description]
   */
  getTemplateVendorList() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-template-vendor-list.do`);
  },
  /**
   * [getTemplateVendorListByCompany 설정 > 네트워크 설정 > 스트립트 설정에서 선택한 벤더에 따른 스크립트 목록을 가져온다.]
   * @author yelim
   * @return {[type]} [description]
   */
  getTemplateVendorListByCompany(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-template-vendor-list-by-company.do`, params);
  },
  /**
   * [getTemplateTypeList 설정 > 네트워크 설정 > 스트립트 설정에서 스크립트 종류 목록을 가져온다.]
   * @author yelim
   * @return {[type]} [description]
   */
  getTemplateTypeList() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-template-type-list.do`);
  },
  /**
   * [deleteNcmTemplateCompany 설정 > 네트워크 설정 > 스트립트 설정에서 스크립트 항목을 삭제한다.]
   * @author yelim
   * @return {[type]} [description]
   */
  deleteNcmTemplateCompany(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/delete-ncm-template-company.do`, params);
  },
  /**
   * [updateNcmTemplate 설정 > 네트워크 설정 > 스트립트 설정에서 스크립트 항목을 수정한다.]
   * @author yelim
   * @return {[type]} [description]
   */
  updateNcmTemplate(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/update-ncm-template.do`, params);
  },
  /**
   * [insertNcmTemplate 설정 > 네트워크 설정 > 스트립트 설정에서 스크립트 항목을 추가한다.]
   * @author yelim
   * @return {[type]} [description]
   */
  insertNcmTemplate(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/insert-ncm-template.do`, params);
  },
  /**
   * [getNmsObjList 설정 > 네트워크 설정 > 스트립트 설정 > 테스트 팝업에서 objCompanyId에 따른 장비 목록을 가져온다.]
   * @author yelim
   * @return {[type]} [description]
   */
  getNmsObjList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-nms-obj-list.do`, params);
  },
  getVendorOidList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-vendor-oid-list.do`, params);
  },
  getVendorInfoList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-vendor-info-list.do`, params);
  },
  /**
   * [insertVendorInfoList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 벤더 OID 사전 항목을 추가한다.]
   * @author yelim
   */
  insertVendorInfoList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/insert-vendor-info-list.do`, params);
  },
  /**
   * [updateVendorInfoList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 벤더 OID 사전 항목을 수정한다.]
   * @author yelim
   */
  updateVendorInfoList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/update-vendor-info-list.do`, params);
  },
  /**
   * [deleteVendorInfoList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 벤더 OID 사전 항목을 삭제한다.]
   * @author yelim
   * @param   params
   */
  deleteVendorInfoList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/delete-vendor-info-list.do`, params);
  },
  /**
   * [getModelOidList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 모델 OID 사전 리스트를 가져온다.]
   * @author yelim
   */
  getModelOidList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-model-oid-list.do`, params);
  },
  /**
   * [insertModelInfoList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 모델 OID 사전 항목을 추가한다.]
   * @author yelim
   */
  insertModelInfoList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/insert-model-info-list.do`, params);
  },
  /**
   * [updateModelInfoList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 모델 OID 사전 항목을 수정한다.]
   * @author yelim
   */
  updateModelInfoList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/update-model-info-list.do`, params);
  },
  /**
   * [insertModelInfoList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 모델 OID 사전 항목을 삭제한다.]
   * @author yelim
   */
  deleteModelInfoList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/delete-model-info-list.do`, params);
  },
  /**
   * [getObjProductList 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 모델 OID 사전 선택한 벤더의 모델 리스트를 가져온다.]
   * @author yelim
   */
  getObjProductList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-obj-product-list.do`, params);
  },
  /**
   * [getPerfOidList 네트워크 설정 > OID 설정 > 성능 OID 사전 > 성능 OID 사전의 목록을 가져온다.]
   * @author yelim
   */
  getPerfOidList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-perf-oid-list.do`, params);
  },
  /**
   * [insertNmsRscTmpl 네트워크 설정 > OID 설정 > 성능 OID 사전 > 템플릿 아이디에 따른 성능 정보를 추가한다.]
   * @author yelim
   */
  insertNmsRscTmpl(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/insert-nms-rsc-tmpl.do`, params);
  },
  /**
   * [deletePerfOidList 네트워크 설정 > OID 설정 > 성능 OID 사전 > 항목을 삭제한다.]
   * @author yelim
   */
  deletePerfOidList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/delete-perf-oid-list.do`, params);
  },
  /**
   * [updateNmsRscTmpl 네트워크 설정 > OID 설정 > 성능 OID 사전 > 항목을 수정한다.]
   * @author yelim
   */
  updateNmsRscTmpl(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/update-nms-rsc-tmpl.do`, params);
  },
  /**
   * [getIsExistVendorModel 네트워크 설정 > OID 설정 > 성능 OID 사전 > 항목이 중복되었는지 여부를 확인한다.]
   * @author yelim
   */
  getIsExistVendorModel(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-is-exist-vendor-model.do`, params);
  },
  /**
   * [getUserDefineOidList 네트워크 설정 > OID 설정 > 사용자 정의 OID > 사용자 정의 OID 목록을 가져온다.]
   * @author yelim
   */
  getUserDefineOidList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-user-define-oid-list.do`, params);
  },
  /**
   * 사용자 정의 OUD의 표현 설종 값을 반환한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getObjRscValueAliasList(params) {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-obj-rsc-value-alias-list.do`, { params });
  },
  /**
   * [getRscDatatypeList 네트워크 설정 > OID 설정 > 사용자 정의 OID 팝업에서 결과 형태 목록을 가져온다.]
   * @author yelim
   */
  getRscDatatypeList() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-rsc-datatype-list.do`);
  },
  /**
   * [getEventJudgeTypes 네트워크 설정 > OID 설정 > 사용자 정의 OID 팝업에서 이벤트 판단 타입 목록을 가져온다.]
   * @author yelim
   */
  getEventJudgeTypes() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-event-judge-types.do`);
  },
  /**
   * [setRscList 네트워크 설정 > OID 설정 > 사용자 정의 OID 항목을 추가한다.]
   * @author yelim
   */
  addUserDefineOid(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/add-user-define-oid.do`, params);
  },
  /**
   * [updateRscList 네트워크 설정 > OID 설정 > 사용자 정의 OID 항목을 수정한다.]
   * @author yelim
   */
  updateUserDefineOid(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/update-user-define-oid.do`, params);
  },
  /**
   * [deleteRscList 네트워크 설정 > OID 설정 > 사용자 정의 OID 항목을 삭제한다.]
   * @author yelim
   */
  deleteUserDefineOidList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/delete-user-define-oid-list.do`, params);
  },
  /**
   * [saveUserdefineGroupApply 네트워크 설정 > OID 설정 > 사용자 정의 OID 그룹저장을 수행한다.]
   */
  saveUserdefineGroupApply(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/save-user-define-oid-group-apply.do`, params);
  },
  isExistVendor(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/is-exist-vendor-oid.do`, params);
  },
  /**
   * [getConfigOidList 네트워크 설정 > 구성 OID 사전 > 구성 OID 리스트를 조회한다.]
   * @author Song
   */
  getConfigOidList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-config-oid-list.do`, params);
  },
  /**
   * [getConfigTmplTargetTypelist 네트워크 설정 > 구성 OID 사전 > 템플릿 타입을 조회한다. ncm_attr_tmpl_target_type]
   * @author Song
   */
  getConfigTmplTargetTypelist() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-config-tmpl-target-type-list.do`);
  },
  /**
   * [getNcmAttrList 네트워크 설정 > 구성 OID 사전 > 템플릿에 추가할 attr 리스트를 조회한다. ncm_attr]
   * @author Song
   */
  getNcmAttrList() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-ncm-attr-list.do`);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 모델 항목이 중복되었는지 여부를 확인한다.]
   * @author Song
   */
  getExistConfigVenderModel(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-exist-config-vender-model.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 모델 항목이 중복되었는지 여부를 확인한다.]
   * @author Song
   */
  getExistPerfVenderModel(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-exist-perft-vender-model.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 구성 OID를 추가한다.]
   * @author Song
   */
  insertConfigTemplate(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/insert-config-template.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 구성 OID 추가 팝업 > 장비 템플릿 선택 시 벤더에 해당하는 장비 리스트 조회]
   * @author Song
   */
  getVenderDeviceForTemplate(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-vender-device-for-template.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 구성 OID 수정 > template_group_id에 해당하는 attr 리스트를 조회한다.]
   * @author Song
   */
  getTargetAttrTmplStatus(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-target-attr-tmpl-status.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 구성 OID를 수정한다.]
   * @author Song
   */
  updateConfigTemplate(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/update-config-template.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 구성 OID를 삭제한다.]
   * @author Song
   */
  deleteConfigTemplate(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/delete-config-template.do`, params);
  },
  /**
   * [네트워크 설정 > 성능 OID 사전 > 템플릿 타입을 조회한다.]
   * @author Song
   */
  getPerfTmplTargetTypelist() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-perf-tmpl-target-type-list.do`);
  },
  /**
   * [네트워크 설정 > OID 설정 > 구성 OID 사전 > 구성 OID 추가 팝업 > 장비 템플릿 선택 시 벤더에 해당하는 장비 리스트 조회]
   * @author Song
   */
  getVenderDeviceForPerfTemplate(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-vender-device-for-perf-template.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 성능 OID 사전 > 성능 OID 사전의 자원목록을 조회한다.]
   * @author Song
   */
  getNmsRscTmplInfoRscList() {
    return axios.get(`${baseUrl}/settings/netdevice-settings/get-vender-device-for-perf-template.do`);
  },
  /**
   * [네트워크 설정 > OID 설정 > 성능 OID 사전 > 모델 OID 적용의 OID 목록을 조회한다.]
   * @author najong
   */
  getModelOidSettingList(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-model-oid-setting-list.do`, params);
  },
  /**
   * 네트워크 설정 > OID 설정 > 벤더/모델 OID 사전 > 모델 OID 적용 모델 OID를 수정.
   * @author najong
   */
  updateNetdeviceModelInfo(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/update-netdevice-model-info.do`, params);
  },
  /**
   * [네트워크 설정 > OID 설정 > 성능 OID 사전 > 모모델 OID 적용 oid별 장비 리스트 조회
   * @author najong
   */
  getObjListByObjOid(params) {
    return axios.post(`${baseUrl}/settings/netdevice-settings/get-obj-list-by-obj-oid.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/netdevice/netdevice-settings.js